/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SwapScreenerLeadResidents200ResponseData } from './SwapScreenerLeadResidents200ResponseData';
import {
    SwapScreenerLeadResidents200ResponseDataFromJSON,
    SwapScreenerLeadResidents200ResponseDataFromJSONTyped,
    SwapScreenerLeadResidents200ResponseDataToJSON,
    SwapScreenerLeadResidents200ResponseDataToJSONTyped,
} from './SwapScreenerLeadResidents200ResponseData';

/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200Response
 */
export interface SwapScreenerLeadResidents200Response {
    /**
     * 
     */
    data?: SwapScreenerLeadResidents200ResponseData;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200Response interface.
 */
export function instanceOfSwapScreenerLeadResidents200Response(value: object): value is SwapScreenerLeadResidents200Response {
    return true;
}

export function SwapScreenerLeadResidents200ResponseFromJSON(json: any): SwapScreenerLeadResidents200Response {
    return SwapScreenerLeadResidents200ResponseFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SwapScreenerLeadResidents200ResponseDataFromJSON(json['data']),
    };
}

export function SwapScreenerLeadResidents200ResponseToJSON(json: any): SwapScreenerLeadResidents200Response {
    return SwapScreenerLeadResidents200ResponseToJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseToJSONTyped(value?: SwapScreenerLeadResidents200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SwapScreenerLeadResidents200ResponseDataToJSON(value['data']),
    };
}

